import { isArray, isPlainObject } from 'lodash/fp';
import { PortableText } from '@ahmdigital/ui';
import React from 'react';

import { OfferCopy, OfferTag, OfferTongueWrapper } from './styles';
import { SectionOfferStrip } from '../../../../../insurance/types';
import getFootnoteSerializer from '../../../../../../utils/get-footnote-serializer';
import insertFootnoteReference from '../../../../../../utils/insert-footnote-reference';
import offerTagImage from '../../../../../../components/offers/images/offer-tag.svg';

type Props = {
  offer: SectionOfferStrip;
};

const OfferTongue = ({ offer }: Props) => {
  const offerTitle = offer?.title;
  const offerFootnote = offer?.footnote;
  return (
    <OfferTongueWrapper>
      <OfferTag src={offerTagImage.src} alt="Offer" />
      <OfferCopy variant="simpleBit">
        <PortableText
          source={insertFootnoteReference({
            footnote: offerFootnote,
            isPortableText: isPlainObject(offerTitle) || isArray(offerTitle),
            text: offerTitle,
          })}
          typeSerializers={getFootnoteSerializer({ footnote: offerFootnote, variant: 'footnote' })}
        />
      </OfferCopy>
    </OfferTongueWrapper>
  );
};

export default OfferTongue;
